import BarCode from './add-card/components/BarCode';

const FidelityCardTile = ({ onClick, img, logo, name, surname, numero }) => {
  const firstLetter = surname?.charAt(0);

  return (
    <div className="fidelity-card-tile white-bg flex flex-col items-center justify-start" onClick={onClick}>
      <div className="flex items-center justify-between w-full px-6 py-2">
        <img
          className="w-[80px]"
          src={logo}
          alt="Logo"
        />
        <div className="flex flex-col">
          <p className="text-xl font-bold">{firstLetter}.{name}</p>
        </div>
      </div>
      
      <div className="flex items-center justify-center w-full px-6 mb-2">
        <img
          className="w-[80px]"
          src={img}
          alt="Carte de fidélité"
        />
      </div>
      
      {/* Barcode */}
      <div className="flex flex-col items-center justify-center w-full px-6">
        <p className="text-lg geomanistMedium text-gray-900 relative top-[4px]">{numero}</p>
        <BarCode value={numero} symbology="CODE128" />
      </div>
      
    </div>
  );
};

export default FidelityCardTile;
